import EbzInputNumber from './EbzInputNumber';

export default EbzInputNumber;
